import { resolvePublicBaseUrl } from "../utils/resolvePublicBaseUrl";

const TITLE_MAX_LENGTH = 70;
const DESCRIPTION_MAX_LENGTH = 160;

const trimToNull = (value) => {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length ? trimmed : null;
};

const readRuntimeOrigin = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return resolvePublicBaseUrl({ skipTrace: true });
};

const isSafeCanonical = (value, origin) => {
  if (!value) {
    return false;
  }

  if (value.startsWith("/")) {
    return true;
  }

  if (!origin) {
    return false;
  }

  try {
    const parsed = new URL(value, origin);
    return parsed.origin === origin;
  } catch {
    return false;
  }
};

/**
 * Keep only safe, public-only SEO override fields.
 * @param {object} templateRule
 * @param {object} override
 * @param {string | undefined} origin
 * @returns {object}
 */
export function sanitizeAgentSeoOverride(templateRule, override, origin) {
  if (!templateRule || templateRule.allowAgentOverride !== true) {
    return {};
  }

  if (!override || typeof override !== "object") {
    return {};
  }

  const safeOverride = {};
  const runtimeOrigin = origin || readRuntimeOrigin();

  if (typeof override.index === "boolean") {
    safeOverride.index = override.index;
  }

  if (typeof override.follow === "boolean") {
    safeOverride.follow = override.follow;
  }

  const title = trimToNull(override.title);
  if (title) {
    safeOverride.title = title.slice(0, TITLE_MAX_LENGTH);
  }

  const description = trimToNull(override.description);
  if (description) {
    safeOverride.description = description.slice(0, DESCRIPTION_MAX_LENGTH);
  }

  const canonicalUrl = trimToNull(override.canonicalUrl);
  if (canonicalUrl && isSafeCanonical(canonicalUrl, runtimeOrigin)) {
    safeOverride.canonicalUrl = canonicalUrl;
  }

  if (templateRule.sitemap === true && typeof override.sitemap === "boolean") {
    safeOverride.sitemap = override.sitemap;
  }

  return safeOverride;
}
